import React from 'react';
import { AGENTS, agentAvatarUrl, openAgentChat } from '../utils/agents';

/** Photo ronde d'un expert, cliquable → ouvrez le chat avec lui. Remplace les icônes « froides » des tuiles. */
export const AgentAvatar = ({ agent = 'sabril', size = 40, ring, urgent = false, testid, className = '', interactive = true }) => {
  const a = AGENTS[agent] || AGENTS.sabril;
  const Root = interactive ? 'button' : 'span';
  return (
    <Root
      type={interactive ? 'button' : undefined}
      onClick={interactive ? (e) => { e.stopPropagation(); openAgentChat(agent); } : undefined}
      className={`relative shrink-0 rounded-[14px] p-[2px] hover:scale-105 active:scale-95 transition-transform ${className}`}
      style={{ width: size, height: size, background: ring || '#E5E5EA' }}
      title={`Discuter avec ${a.name} · ${a.role}`}
      aria-label={`Discuter avec ${a.name}`}
      data-testid={testid || `agent-avatar-${agent}`}
    >
      <img src={agentAvatarUrl(agent)} alt="" className="w-full h-full rounded-[14px] object-cover bg-[var(--carte)]" loading="lazy" />
      {urgent && <span className="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 rounded-full bg-[var(--p-d9442b)] ring-2 ring-white live-dot" />}
    </Root>
  );
};

export default AgentAvatar;
